import React, { useState } from 'react';
import './selectionToggle.scss';

interface IMonthlyView {
    getSelection(value: number): any;
}

const SelectionToggle = ({ getSelection }: IMonthlyView) => {
    const [selected, setSelected] = useState<number>(1);

    const changeValue = (value: number) => {
        setSelected(value);
        getSelection(value);
    };

    return (
        <div className="timeSelectionToggleComponent">
            <div
                onClick={() => {
                    changeValue(1);
                }}
                className={`selectItem ${selected == 1 ? 'selectedItem' : ''}`}
            >
                일
            </div>
            <div
                onClick={() => {
                    changeValue(2);
                }}
                className={`selectItem ${selected == 2 ? 'selectedItem' : ''}`}
            >
                주
            </div>
            <div
                onClick={() => {
                    changeValue(3);
                }}
                className={`selectItem ${selected == 3 ? 'selectedItem' : ''}`}
            >
                월
            </div>
        </div>
    );
};

export default SelectionToggle;
